import { useState, useEffect } from 'react';
import { fetchMission, MissionPayload } from '../services/missionService';

export const useMission = () => {
  const [mission, setMission] = useState<MissionPayload | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadMission = async () => {
      try {
        setLoading(true);
        const data = await fetchMission();
        setMission(data);
        setError(null);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load mission data');
        setMission(null);
      } finally {
        setLoading(false);
      }
    };

    loadMission();
  }, []);

  return { mission, loading, error };
};
